// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__VB2nr","overlay":"banner_overlay__+6Ud6","bannerTitle":"banner_bannerTitle__vhQH8"};